import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Login from "./components/login";
import Router from "./components/router";
import Confirmation from "./components/registration/confirmation.js";
import Questionnaire from "./components/questionnaires/questionnaire.js";
import ResetPassword from "./components/login";
import isInterventionRegistrationRedirect from "./components/helpers/interventionRedirects";
import EduRegistration from "./components/registration/edu";
import "./App.scss";
import "./App.css";

const App = () => {

  const auth = useSelector(state => state.auth);

  const [confirmation, setConfirmation] = useState(false);
  const [questionnaire, setQuestionnaire] = useState(false);
  const [resetpassword, setResetPassword] = useState(false);
  const [eduRegistration, setEduRegistration] = useState(false);
  const [eduCoachToken, setEduCoachToken] = useState('');
  const [eduInterventionSlug, setEduInterventionSlug] = useState('');

  useEffect(() => {
    //Gebruik pathname (zonder querystring) zodat /edu?coach=... ook correct matcht.
    //Vóór deze fix gaf split('/') op href '["https:","","host","edu?coach=..."]' wat
    //niet matchte op === 'edu' → de gebruiker belandde op de login-pagina.
    const pathParts = window.location.pathname.split("/").filter(p => p.length > 0);
    const firstSegment = pathParts[0] || '';
    const secondSegment = pathParts[1] || '';
    const urlParams = new URLSearchParams(window.location.search);

    if (firstSegment === 'registration' || firstSegment === 'edu')
    {
      //registratie en /edu lopen beide via de edu-flow
      setEduCoachToken(urlParams.get('coach') || '');
      setEduInterventionSlug(secondSegment);
      setEduRegistration(true);
    }
    else if (firstSegment === 'confirmation')
    {
      setConfirmation(true);
    }
    else if (firstSegment === 'questionnaire')
    {
      setQuestionnaire(true);
    }
    else if (firstSegment === 'resetpassword')
    {
      setResetPassword(true);
    }
    else if (firstSegment === 'login_as_coach')
    {
      const token = urlParams.get('token');
      document.cookie = "token=" + token + "; path=/";
      window.location.href = "/";
    }
    else if (isInterventionRegistrationRedirect(firstSegment)) {
      //interventie-specifieke landingpages (bv. /lifehack) → edu-flow met slug
      setEduCoachToken(urlParams.get('coach') || '');
      setEduInterventionSlug(firstSegment);
      setEduRegistration(true);
    }
  }, [])

  return (
    <div id="wrapper">
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
      />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
      />
      {
        eduRegistration === true ? <EduRegistration coachToken={eduCoachToken} interventionSlug={eduInterventionSlug} /> :
          <>
            {
              confirmation === true ? <Confirmation setConfirmation={setConfirmation} /> :
                <>
                  {
                    questionnaire === true ? <Questionnaire /> :
                      <>
                        {
                          resetpassword === true ? <ResetPassword /> :
                            <>
                              {
                                auth.status === true ? <Router /> : <Login />
                              }
                            </>
                        }
                      </>
                  }
                </>
            }
          </>
      }
      <div className="overlay"></div>
    </div>
  );
}

export default App;
